import React, { useCallback } from 'react';
import store, { IAppReduxStore } from '../../../../redux/store';
import { Stack } from '@mui/material';
import { useSelector } from 'react-redux';
import { hideCategorizationDialog } from '../../../../redux/general/sliceCategorization';
import { fullSize } from '../../../../Constants';
import { Area } from '../../../../types';
import WorkflowDialogs from '../Workflow/WorkflowDialogs';
import DocumentDetailsDialog from '../DocumentDetailsDialog';
import ProjectDocumentationDialog from '../ProjectDocumentationDialog/ProjectDocumentationDialog';
import CategorizationDialog from '../CategorizationDialog/CategorizationDialog';
import CreateSupportTicketDialog from '../CreateSupportTicketDialog/CreateSupportTicketDialog';
import DocumentsStateDialog from '../DocumentsStateDialog';
import RemoveAdditionalDocDialog from '../RemoveAdditionalDocument/RemoveAdditionalDocDialog';
import ExcelUploadDialog from '../ExcelUploadDialog/ExcelUploadDialog';
import DatabaseAccessDialog from '../DatabaseAccessDialog/DatabaseAccessDialog';
import UploadAdditionalDocumentDialog from '../UploadAdditionalDocumentDialog/UploadAdditionalDocumentDialog';
import CreateReportDialog from '../CreateReportDialog/CreateReportDialog';
import ReleaseLetterDialog from '../ReleaseLetterDialog/ReleaseLetterDialog';
import NoteDialog from '../NoteDialog/NoteDialog';
import DeleteImportDocumentsDialog from '../DeleteImportDocumentsDialog/DeleteImportDocumentsDialog';
import ShareEmailDialog from '../ShareEmailDialog/ShareEmailDialog';
import AdvancedExportDocumentsDialog from '../AdvancedExportDocumentsDialog/AdvancedExportDocumentsDialog';
import DynamicSelectionDialog from '../DynamicSelectionDialog/DynamicSelectionDialog';
import CreateNoticeDialog from '../CreateNoticeDialog/CreateNoticeDialog';
import WebDAVDecisionDialog from '../WebDAVDecisionDialog/WebDAVDecisionDialog';
import SaveAssemblyDialog from '../AssemblyDialogs/SaveAssemblyDialog';
import ViewFileErrorDialog from '../ViewFileErrorDialog/ViewFileErrorDialog';
import FileSelectionDialog from '../FileSelectionDialog/FileSelectionDialog';
import ChangeAdditionalDocumentStatusDialog from '../ChangeAdditionalDocumentStatusDialog/ChangeAdditionalDocumentStatusDialog';
import AddDocumentFilesDialog from '../AddDocumentFilesDialog/AddDocumentFilesDialog';
import SignMeCredentialsDialog from '../SignMeCredendialsDialog/SignMeCredentialsDialog';
import NewAssemblyIndexDialog from '../NewAssemblyIndexDialog/NewAssemblyIndexDialog';

/**
 * Application view that allows the uer to navigate through a project database.
 */
export default ({ area, children }: IDialogsWrapperProps) => {
    const { isDialogOpen: isDocumentDetailsDialogOpen } = useSelector(
        (store: IAppReduxStore) => store.projectDocumentDetails,
    );
    const { isDialogOpen: isProjectDocumentationDialogOpen } = useSelector(
        (store: IAppReduxStore) => store.projectDocumentation,
    );
    const { showDialog: isCategorizationDialogOpen } = useSelector(
        (store: IAppReduxStore) => store.categorization,
    );
    const { isDialogOpen: isExcelUploadDialogOpen } = useSelector(
        (store: IAppReduxStore) => store.excelUpload,
    );
    const { isDialogOpen: isDocumentsStateDialogOpen } = useSelector(
        (store: IAppReduxStore) => store.projectDocumentsActivation,
    );
    const { isRemoveAdditionalDocDialogOpen } = useSelector(
        (store: IAppReduxStore) => store.projectAdditionalDocs,
    );
    const { isDialogOpen: isDatabaseAccessDialogOpen } = useSelector(
        (store: IAppReduxStore) => store.databaseAccess,
    );
    const { isDialogOpen: isUploadAdditionalDocumentsDialogOpen } = useSelector(
        (store: IAppReduxStore) => store.projectUploadAdditionalDocuments,
    );
    const { isDialogOpen: isCreateReportDialogOpen } = useSelector(
        (store: IAppReduxStore) => store.projectDocumentsReportFromTemplate,
    );
    const { isDialogOpen: isReleaseLetterDialogOpen } = useSelector(
        (store: IAppReduxStore) => store.projectDocumentsAddReleaseLetter,
    );
    const { isDialogOpen: isDocumentsShareEmailDialogOpen } = useSelector(
        (store: IAppReduxStore) => store.projectDocumentsShareEmail,
    );
    const { isDialogOpen: isDocumentAddNoteDialogOpen } = useSelector(
        (store: IAppReduxStore) => store.documentAddNote,
    );
    const { isDialogOpen: isSupportTicketCreationDialogOpen } = useSelector(
        (store: IAppReduxStore) => store.projectSupportTicketCreation,
    );
    const { isDialogOpen: isImportDeleteDocumentDialogOpen } = useSelector(
        (store: IAppReduxStore) => store.importDeleteDocuments,
    );
    const { isDialogOpen: isAdvancedExportDialogOpen } = useSelector(
        (store: IAppReduxStore) => store.projectAdvancedExportDialog,
    );
    const { isDialogOpen: isDynamicSelectionDialogOpen } = useSelector(
        (store: IAppReduxStore) => store.projectDocumentsDynamicSelection,
    );
    const { isDialogOpen: isCreateNoticeDialogOpen } = useSelector(
        (store: IAppReduxStore) => store.projectDocumentsCreateNotice,
    );
    const { isSaveAssemblyDialogOpen } = useSelector(
        (store: IAppReduxStore) => store.projectSaveAssembly,
    );
    const { isChangeCredentialsDialogOpen } = useSelector(
        (store: IAppReduxStore) => store.projectUserSignatureSettings,
    );
    const {
        webDAVDecisionDialog: isWebDAVDecisionDialogOpen,
        fileSelectDialog: isFileSelectionDialogOpen,
        error: isViewFileErrorDialogOpen,
    } = useSelector((store: IAppReduxStore) => store.projectFileOpen);
    const { isDialogOpen: isChangeAdditionalDocumentStatusDialogOpen } = useSelector(
        (store: IAppReduxStore) => store.projectDocumentChangeReleaseStatus,
    );
    const { config: isAddDocumentFilesDialogOpen } = useSelector(
        (store: IAppReduxStore) => store.fileUpload.addDocumentFilesDialogState,
    );
    const { isDialogOpen: isNewAssemblyIndexDialogOpen } = useSelector(
        (store: IAppReduxStore) => store.projectNewAssemblyIndex,
    );

    const onCategorizationDialogClose = useCallback(() => {
        store.dispatch(hideCategorizationDialog());
    }, []);

    return (
        <Stack direction='column' sx={{ ...fullSize, flexGrow: 4, overflow: 'hidden' }}>
            {children}
            <WorkflowDialogs />
            {isDocumentDetailsDialogOpen && <DocumentDetailsDialog />}
            {isProjectDocumentationDialogOpen && <ProjectDocumentationDialog />}
            {isCategorizationDialogOpen && area && (
                <CategorizationDialog onClose={onCategorizationDialogClose} area={area} />
            )}
            {isSupportTicketCreationDialogOpen && <CreateSupportTicketDialog />}
            {isDocumentsStateDialogOpen && <DocumentsStateDialog />}
            {isRemoveAdditionalDocDialogOpen && <RemoveAdditionalDocDialog />}
            {isExcelUploadDialogOpen && <ExcelUploadDialog />}
            {isDatabaseAccessDialogOpen && <DatabaseAccessDialog />}
            {isUploadAdditionalDocumentsDialogOpen && <UploadAdditionalDocumentDialog />}
            {isCreateReportDialogOpen && <CreateReportDialog />}
            {isReleaseLetterDialogOpen && <ReleaseLetterDialog />}
            {isDocumentAddNoteDialogOpen && <NoteDialog />}
            {isImportDeleteDocumentDialogOpen && <DeleteImportDocumentsDialog />}
            {isDocumentsShareEmailDialogOpen && <ShareEmailDialog />}
            {isAdvancedExportDialogOpen && <AdvancedExportDocumentsDialog />}
            {isDynamicSelectionDialogOpen && <DynamicSelectionDialog />}
            {isCreateNoticeDialogOpen && <CreateNoticeDialog />}
            {isWebDAVDecisionDialogOpen && <WebDAVDecisionDialog />}
            {isSaveAssemblyDialogOpen && <SaveAssemblyDialog />}
            {isViewFileErrorDialogOpen && <ViewFileErrorDialog />}
            {isChangeAdditionalDocumentStatusDialogOpen && <ChangeAdditionalDocumentStatusDialog />}
            {isFileSelectionDialogOpen && <FileSelectionDialog />}
            {isAddDocumentFilesDialogOpen && <AddDocumentFilesDialog />}
            {isChangeCredentialsDialogOpen && <SignMeCredentialsDialog />}
            {isNewAssemblyIndexDialogOpen && <NewAssemblyIndexDialog />}
        </Stack>
    );
};

interface IDialogsWrapperProps extends React.PropsWithChildren {
    area?: Area;
}
